// extracted by mini-css-extract-plugin
export var brand = "_1h-9";
export var compact = "_1h-6";
export var extraSmall = "_1h-7";
export var icon = "_1h-0";
export var large = "_1h-4";
export var light = "_1h-1";
export var medium = "_1h-5";
export var outline = "_1h-b";
export var primaryDark = "_1h-a";
export var primaryLight = "_1h-8";
export var primaryModern = "_1h-c";
export var success = "_1h-2";
export var successSolid = "_1h-3";